import { createSlice } from '@reduxjs/toolkit';
import { m } from '../../../utils/date'
const initialState = {
    data: [],
    page: {
        page: 1,
        size: 10,
        totalPage: 1,
        totalSize: 1,
    }
};

const partnerSlice = createSlice({
    name: 'partner',
    initialState,
    reducers: {
        funGetPartner(state, action){
            const { list, page, size, totalPage, totalSize } = action.payload;
            state.data = list.map(( partner ) => {
                return{
                    ...partner,
                    registrationDt: m.date({ value: partner.registrationDt }),
                }
            });
            state.page = { page, size, totalPage, totalSize };
        }
    },
});

export const partnerActions = partnerSlice.actions;
export default partnerSlice.reducer;